module.exports = "uniform float uStrength;\n\nvoid main()\n{\n    vec4 newPosition = modelViewMatrix * vec4(position, 1.0);\n    vec3 newNormal = normalize(normalMatrix * normal);\n\n    newPosition.xyz += newNormal * uStrength;\n\n    gl_Position = projectionMatrix * newPosition;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/libs/experience/shaders/token-outline/vertex.glsl
// module id = 413
// module chunks = 0